export default __webpack_public_path__ + "static/media/html_ico.29ce1f6e.svg";